import React from "react";

const UnverifiedPrompt = ({ email, onResend, resendStatus }) => {
  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Check Your Inbox</h2>
      <p style={styles.subheading}>
        We’ve sent a verification link to <strong>{email}</strong>. Please click the link to verify your account.
      </p>
      <p style={styles.subheading}>
        Once verified, you’ll be able to log in.
      </p>
      <button style={styles.resendButton} onClick={onResend}>
        Resend Verification Email
      </button>
      {resendStatus && <p style={styles.status}>{resendStatus}</p>}
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    padding: "20px",
    maxWidth: "360px",
    margin: "0 auto",
  },
  heading: {
    fontSize: "24px",
    fontWeight: 600,
    marginBottom: "10px",
    color: "#333",
  },
  subheading: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "20px",
    lineHeight: "1.4",
  },
  resendButton: {
    backgroundColor: "#28a745",
    color: "#fff",
    fontSize: "16px",
    padding: "12px 20px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },
  status: {
    color: "green",
    fontSize: "14px",
    marginTop: "10px",
  },
};

export default UnverifiedPrompt;
